(() => {
  const init = () => {
    const root = document.querySelector('[data-lnl-pdp]');
    if (!root || root.dataset.croReady) return;
    root.dataset.croReady = 'true';
    const reviewTemplate = root.querySelector('template[data-lnl-review-template]');
    const proof = root.querySelector('#lnl-reviews');
    const loadReviews = () => {
      if (!reviewTemplate?.isConnected) return;
      const fragment = reviewTemplate.content.cloneNode(true);
      fragment.querySelectorAll('script[type="application/ld+json"]').forEach((script) => script.remove());
      const scripts = [...fragment.querySelectorAll('script')];
      reviewTemplate.replaceWith(fragment);
      scripts.forEach((placeholder) => {
        const script = document.createElement('script');
        [...placeholder.attributes].forEach((attribute) => script.setAttribute(attribute.name, attribute.value));
        script.textContent = placeholder.textContent;
        placeholder.replaceWith(script);
      });
      root.querySelector('[data-lnl-review-loading]')?.remove();
      // Re-run the installed app loader against the now-present native app block.
      const originalLoader = [...document.scripts].find((script) => script.src.includes('/judgeme-') && script.src.includes('/assets/loader.js'));
      if (originalLoader && window.jdgm) {
        window.jdgm._loaderExecuted = false;
        const loader = document.createElement('script');
        loader.src = originalLoader.src;
        loader.async = true;
        loader.dataset.lnlReviewReload = 'true';
        document.head.appendChild(loader);
      }
    };
    root.querySelectorAll('[href="#lnl-reviews"]').forEach((link) => link.addEventListener('click', loadReviews, { once: true }));
    if (proof && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) { loadReviews(); observer.disconnect(); }
      }, { rootMargin: '500px' });
      observer.observe(proof);
    } else { loadReviews(); }
    const lead = root.querySelector('[data-lnl-gallery-slide] img');
    const release = () => {
      const templates = [...root.querySelectorAll('template[data-lnl-near-image]')];
      const hydrate = (template) => {
        if (template.isConnected) template.replaceWith(template.content.cloneNode(true));
      };
      if ('IntersectionObserver' in window) {
        const imageObserver = new IntersectionObserver((entries) => {
          entries.filter((entry) => entry.isIntersecting).forEach((entry) => {
            entry.target.querySelectorAll('template[data-lnl-near-image]').forEach(hydrate);
            imageObserver.unobserve(entry.target);
          });
        }, { rootMargin: '400px' });
        [...new Set(templates.map((template) => template.parentElement))].forEach((parent) => imageObserver.observe(parent));
      } else { templates.forEach(hydrate); }
    };
    if (!lead || (lead.complete && lead.naturalWidth)) release();
    else { lead.addEventListener('load', release, { once: true }); lead.addEventListener('error', release, { once: true }); }
    const quote = root.querySelector('[data-lnl-customer-quote]');
    const reviewRoot = reviewTemplate?.content || root;
    // Near-buy quote: a verbatim excerpt from a live review on THIS product. Only scent/feel lines, never results claims.
    const picks = {
      'green-and-jaded': { author: 'Avery', excerpt: 'I honestly LOVE it. The scent/taste is unreal. It\'s not super sticky, which I like', ellipsis: true },
      'buttered-up': { author: 'Mariah', excerpt: 'I LOVE them. The fact that you can smell them so vividly is just so unique.', ellipsis: false }
    };
    const handle = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
    const pick = picks[handle];
    const review = pick && [...reviewRoot.querySelectorAll('.jdgm-rev')].find((rev) => {
      const author = rev.querySelector('.jdgm-rev__author')?.textContent.trim() || '';
      const body = (rev.querySelector('.jdgm-rev__body')?.textContent || '').replace(/[\u2018\u2019]/g, "'").trim();
      return author.startsWith(pick.author) && body.startsWith(pick.excerpt.replace(/[\u2018\u2019]/g, "'"));
    });
    if (quote && review) {
      const gifted = (review.querySelector('.jdgm-rev__title')?.textContent || '').startsWith('Gifted');
      const text = document.createElement('p');
      text.textContent = `“${pick.excerpt}${pick.ellipsis ? '…' : ''}”`;
      const citation = document.createElement('cite');
      citation.textContent = `${review.querySelector('.jdgm-rev__author').textContent.trim()}${gifted ? ' · Gifted' : ''}`;
      quote.replaceChildren(text, citation);
      quote.hidden = false;
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
